<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: meta.links.show,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>{{ $t('messages.information') }}</div>
                    <img v-if="group.image_path" class="w-40 h-40 object-contain" :src="group.image_path" alt="" />
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput id="name" v-model="form.name" name="name" type="text" max="60" class="mt-1" />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.image')" for="image" />
                            <input
                                id="image"
                                @input="form.image = $event.target.files[0]"
                                name="image"
                                type="file"
                                accept="image/*"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.image" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import Layout from '@/Shared/Layout.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'group'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'patch',
                name: this.group.name,
                image: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
    },
};
</script>
